import React from 'react';
import './App.scss';
import { Header } from './components/Header';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";


//Declare New Components Here
import Home from './components/Home';
import PersonalDetails from "./components/PersonalDetails.jsx";
import FundTransfer from "./components/FundTransfer";
import ReviewDetails from "./components/ReviewDetails";
import errorscreen from "./components/error";

function App() {
  return (
    <Router>
      <div className="content">
        <Header projectName={'mbank_fundtransfer'} />
        <Route exact path="/" ><Redirect to="/dcofvcsa/PersonalDetails" /></Route>
        {/* <Route exact path="/dcofvcsa" component={Home} /> */}
        <Route exact path="/dcofvcsa" ><Redirect to="/dcofvcsa/PersonalDetails" /></Route>
        <Route exact path="/dcofvcsa/dcofvcsa" ><Redirect to="/dcofvcsa/PersonalDetails" /></Route>
        <Route path="/dcofvcsa/PersonalDetails" component={PersonalDetails} />
        <Route path="/dcofvcsa/Details" component={FundTransfer} />
        <Route path="/dcofvcsa/ReviewDetails" component={ReviewDetails} />
        <Route path="/dcofvcsa/error" component={errorscreen} />
      </div>
      <br></br><br></br>
    </Router>
  );
}


export default App;
